module.exports = __webpack_public_path__ + "static/img/tersa_00.b63a5ac.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/tersa_00.jpg
// module id = xKNU
// module chunks = 0